import React, { useState, useRef, useLayoutEffect } from "react";
import PropTypes from "prop-types";
import styled from "styled-components/macro";
import store from "../store";

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Sintony";
  font-size: 1rem;
  font-weight: bold;
  line-height: 0;
  margin: 0;
  padding: 0;
  padding: ${4 / 16}rem ${21 / 16}rem;
  border-radius: 50px;
  box-shadow: 0 0 ${10 / 16}rem rgba(0, 0, 0, 0.13);
  margin-top: .5rem;

  @media (min-width: 1024px) {
    height: 40px;
    padding: ${8 / 16}rem 0;
    font-size: ${18 / 16}rem;
    min-width: ${200 / 16}rem;

  }

  svg {
    ${(props) => props.iconWidth && `width: ${props.iconWidth};`};
    ${(props) => props.iconHeight && `height: ${props.iconHeight};`};
  }
  svg path {
    ${(props) => (props.fillColor ? `fill: ${props.fillColor};` : "")}
    ${(props) => (props.strokeColor ? `stroke: ${props.strokeColor};` : "")}
  }
  svg line {
    ${(props) => (props.strokeColor ? `stroke: ${props.strokeColor};` : "")}
  }
  span {
    padding-left: 0;
  }

  color: ${(props) => props.theme.primaryDark};
  background-color: ${(props) => props.theme.bgButtonLightDefault};
  border: none;

  &:hover {
    cursor: pointer;
    background-color: ${(props) => props.theme.bgDarkHover};
  }
  &:active {
    cursor: pointer;
    opacity: 73%;
    background-color: ${(props) => props.theme.bgDarkClick};
  }

  //Prop specific effects
  ${(props) =>
    props.matchIconFillToText &&
    `
    &.light svg path{
      fill: ${props.theme.textLightDefault};
    }
    &.dark svg path {
      fill: ${props.theme.textDarkDefault};
    }
  `}
  ${(props) =>
    props.matchIconStrokeToText &&
    `
    &.light svg line {
      stroke: ${props.theme.textLightDefault};
    }
    &.dark svg line {
      stroke: ${props.theme.textDarkDefault};
    }
  `}

  &.candle {
    font-family: "Sintony";
    font-weight: bold;
    background-color: ${(props) => props.theme.bgDarkDefault};
    color: ${(props) => props.theme.textDarkDefault};
    height: ${48 / 16}rem;
    width: ${119 / 16}rem;
    border-left: none;
    border-radius: 0 50px 50px 0;
    border-color: #7D6A2D;
    padding: ${7 / 16}rem ${16 / 16}rem ${7 / 16}rem 0;

    svg path {
      stroke: ${(props) => props.theme.textDarkDefault};
    }

    &:hover {
      background-color: ${(props) => props.theme.primaryLight};
      color: ${(props) => props.theme.textDarkHover};

    }
    &:active {
      background-color: ${(props) => props.theme.bgDarkClick};
      color: ${(props) => props.theme.textDarkClick};
      opacity: 1;
    }
    @media (min-width: 1024px) {
      padding: ${11 / 16}rem ${24 / 16}rem ${11 / 16}rem 0;
    }
  }

  // Themes

  &.back {
    color: ${(props) => props.theme.textBackButton};
    background-color: ${(props) => props.theme.bgBackButtonLightDefault};
    border-left: none;
    border-radius: 0 50px 50px 0;
    min-width: 6rem;

    span {
      padding-left: 0;
      padding-right: 0.75rem;
    }

    &:hover {
      background-color: ${(props) => props.theme.bgBackButtonHoverLightDefault};
    }
    &:active {
      color: ${(props) => props.theme.textLightDefault};
    }

    svg path,
    svg line {
      stroke: ${(props) => props.theme.textBackButton};
    }
  }
`;

const ButtonContent = styled.span`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  margin: 0;
  line-height: 0;
  padding: 0;

  //padding: ${9.5 / 16}rem ${21 / 16}rem;
`;

const MapButton = ({
  label,
  icon,
  classState,
  type,
  action,
  addClass,
  addStyle,
  isLink,
  link,
  matchIconFillToText,
  matchIconStrokeToText,
  iconWidth,
  iconHeight,
}) => {
  const [state, setState] = useState(store.initialState);
  const sub = useRef(null);

  useLayoutEffect(() => {
    sub.current = store.subscribe(setState);
    store.init();
    return () => {
      store.unsubscribe(sub.current);
    };
  }, []);

  return (
    <StyledButton
      onClick={action}
      className={`${type} ${classState} ${
        !label && icon ? "icon-only" : ""
      } ${addClass}`}
      style={addStyle}
      as={isLink ? "a" : "button"}
      href={isLink ? link : ""}
      target={isLink ? "_blank" : ""}
      disabled={state === "inactive"}
      matchIconFillToText={matchIconFillToText}
      matchIconStrokeToText={matchIconStrokeToText}
      iconWidth={iconWidth}
      iconHeight={iconHeight}
      headerColor={state.headerThemeColor}
    >
      <ButtonContent>
        {icon} {label}
      </ButtonContent>
    </StyledButton>
  );
};

MapButton.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.object,
  state: PropTypes.string,
  type: PropTypes.string,
  action: PropTypes.func,
  addClass: PropTypes.string,
  addStyle: PropTypes.object,
  isLink: PropTypes.bool,
  link: PropTypes.string,
  fillColor: PropTypes.string,
  strokeColor: PropTypes.string,
};

MapButton.defaultProps = {
  label: null,
  icon: null,
  state: null,
  type: null,
  action: null,
  addClass: null,
  addStyle: null,
  isLink: false,
  link: "",
  fillColor: null,
  strokeColor: null,
};

export default MapButton;
